
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[profileName]",
      function () {
        return require("private-next-pages/[profileName]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[profileName]"])
      });
    }
  